/*
 * Sleep Essentials Bundle — ATC handler.
 * Loaded only on /products/sleep-essentials-bundle.
 *
 * Updated 2026-06-21: the bundle is now a single dedicated Shopify SKU
 * (product id 10589565944102) with 4 variants by size × firmness. The PDP's
 * size + firmness pickers select one of those variants and a normal Add to
 * Cart fires a single cart/add.js with one line item.
 *
 * Previously this script hijacked submit and added 4 pillows + 2 pillowcase
 * sets as separate lines stamped with _target_total_cents — that machinery is
 * no longer needed because the bundle SKU prices itself in Shopify
 * ($183 Standard / $210 King).
 *
 * The cart still receives `_bundle_source: 'sleep-essentials-bundle'` so the
 * pillowcase-set GWP suppression in fluffco-cart.js keeps working (the bundle
 * already includes pillowcases, so we don't want to award them as a GWP too).
 */
(function () {
  var ROOT_SELECTOR = '[data-fc-pdp][data-handle="sleep-essentials-bundle"]';
  var FORM_SELECTOR = '[data-fc-atc-form]';

  // Variants of the dedicated bundle product (gid://shopify/Product/10589565944102)
  var VARIANTS = {
    'Standard|Soft Fluff™': 53321930637606,
    'Standard|Firm Fluff™': 53321930703142,
    'King|Soft Fluff™':     53321930670374,
    'King|Firm Fluff™':     53321930735910
  };

  function readSize(root) {
    var sel = root.querySelector('[data-fc-size-btn].is-active, [data-fc-size].is-active');
    if (sel) {
      var v = (sel.dataset.fcSizeBtn || sel.dataset.fcSize || sel.textContent || '').trim();
      if (v.toLowerCase().indexOf('king') > -1) return 'King';
    }
    return 'Standard';
  }

  function readFluff(root) {
    var sel = root.querySelector('[data-fc-firmness].is-active, [data-fc-firmness-btn].is-active');
    if (sel) {
      var v = (sel.dataset.fcFirmness || sel.dataset.fcFirmnessBtn || sel.textContent || '').trim();
      if (v.toLowerCase().indexOf('firm') > -1) return 'Firm Fluff™';
    }
    return 'Soft Fluff™';
  }

  function variantFor(size, fluff) {
    return VARIANTS[size + '|' + fluff] || VARIANTS['Standard|Soft Fluff™'];
  }

  function init() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    var form = root.querySelector(FORM_SELECTOR);
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      var atcBtn = form.querySelector('[data-fc-atc]');
      var atcTextEl = form.querySelector('[data-fc-atc-text]');
      var origText = atcTextEl ? atcTextEl.textContent : '';

      var size  = readSize(root);
      var fluff = readFluff(root);
      var variantId = variantFor(size, fluff);

      var payload = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            _bundle_source: 'sleep-essentials-bundle',
            _bundle_size: size,
            _bundle_fluff: fluff
          }
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) throw new Error('cart/add failed: ' + r.status);
        return r.json();
      }).then(function () {
        if (atcBtn) atcBtn.classList.add('is-added');
        if (atcTextEl) atcTextEl.textContent = '✓ Added to Cart!';
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open(atcBtn);
        else document.dispatchEvent(new CustomEvent('cart:item-added'));
        setTimeout(function () {
          if (atcBtn) atcBtn.classList.remove('is-added');
          if (atcTextEl) atcTextEl.textContent = origText;
        }, 2000);
      }).catch(function (err) {
        console.error('[SEB ATC] failed:', err);
        if (atcTextEl) atcTextEl.textContent = 'Try again';
      });
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
